import { Viewer } from "cesium";
import {
  createContext,
  PropsWithChildren,
  use,
  useEffect,
  useState,
} from "react";
import CesiumWrapper from "./wrapper/CesiumWrapper";

type CesiumState = {
  viewer: Viewer;
  isReady: boolean;
};
const defaultState: CesiumState = {
  viewer: null,
  isReady: false,
};

const CesiumContext = createContext<ReturnType<typeof useProvider>>(null);

export const useCesium = () => use(CesiumContext);

export const CesiumProvider = ({ children }: PropsWithChildren<{}>) => {
  const value = useProvider();
  return <CesiumContext value={value}>{children}</CesiumContext>;
};

const useProvider = () => {
  const [state, setState] = useState<CesiumState>(defaultState);
  const wrapper = useState(() => new CesiumWrapper())[0];

  const initialize = (viewer: Viewer) => {
    wrapper.setViewer(viewer);
    setState({
      viewer,
      isReady: true,
    });
  };

  useEffect(() => {
    return () => {
      if (state.viewer) {
        wrapper.detachViewer();
        state.viewer.destroy();
      }
      setState(null);
    };
  }, []);

  return {
    initialize,
    wrapper,
    toolManager: wrapper.toolManager,
    ...wrapper.plugins,
    ...state,
  };
};
